import { render, staticRenderFns } from "./StateTable.vue?vue&type=template&id=20c695d7&scoped=true&"
import script from "./StateTable.vue?vue&type=script&lang=js&"
export * from "./StateTable.vue?vue&type=script&lang=js&"
import style0 from "./StateTable.vue?vue&type=style&index=0&id=20c695d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c695d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
